import { render, staticRenderFns } from "./TemplatesArchive.vue?vue&type=template&id=7ec2a38a&scoped=true"
import script from "./TemplatesArchive.vue?vue&type=script&lang=js"
export * from "./TemplatesArchive.vue?vue&type=script&lang=js"
import style0 from "./TemplatesArchive.vue?vue&type=style&index=0&id=7ec2a38a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec2a38a",
  null
  
)

export default component.exports